package de.emgress.baskets.modules.schedule

import androidx.compose.runtime.Composable
import core.enums.EActivityStateDB
import core.utils.TimeUtils
import de.emgress.baskets.core.extensions.isMobile
import de.emgress.baskets.core.styles.Styles
import de.emgress.baskets.modules.components.GameDayInformation
import dtos.games.outgoing.GameInfoDTOOut
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun GameMetadata(
    game: GameInfoDTOOut,
    gameDayInSeason: Int
) {
    Div({
        classes(Styles.cssClasses.rowCentered)
    }) {
        P({
            classes(Styles.cssClasses.largerParagraph, Styles.cssClasses.bold, Styles.cssClasses.passionOneFont, if(window.isMobile().not()) Styles.cssClasses.marginMedium else Styles.cssClasses.marginSmall)
        }) {
            Text(if (game.mActivityState == EActivityStateDB.NOT_STARTED) "-" else game.mHomeScore.toString())
        }
        if (window.isMobile().not() && game.mActivityState != EActivityStateDB.ACTIVE) {
            Div({
                classes(Styles.cssClasses.column)
                style {
                    width(120.px)
                }
            }) {
                GameDayInformation(gameDayInSeason, game)
            }
        } else if (window.isMobile() && game.mActivityState != EActivityStateDB.ACTIVE) {
            P({
                classes(Styles.cssClasses.largerParagraph, Styles.cssClasses.bold, Styles.cssClasses.passionOneFont)
            }) {
                Text(":")
            }
        }

        if (game.mActivityState == EActivityStateDB.ACTIVE) {
            Div({
                classes(Styles.cssClasses.column)
            }) {
                P({
                    classes(Styles.cssClasses.paragraph, Styles.cssClasses.bold, Styles.cssClasses.barlowFont)
                }) {
                    Text("LIVE!")
                }
            }
        }
        P({
            classes(Styles.cssClasses.largerParagraph, Styles.cssClasses.bold, Styles.cssClasses.passionOneFont, if(window.isMobile().not()) Styles.cssClasses.marginMedium else Styles.cssClasses.marginSmall)
        }) {
            Text(if (game.mActivityState == EActivityStateDB.NOT_STARTED) "-" else game.mGuestScore.toString())
        }
    }
}